import { useEffect, useState } from 'react';
import { gstAPI } from '../../services/api';

export const inr = (n) => Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const msg = (e) => e?.response?.data?.message || e?.message || 'Something went wrong';
export const GST_RATES = [0, 5, 12, 18, 28];
// Today's date in India, as YYYY-MM-DD (the business runs on IST).
export const today = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
export const dmy = (iso) => { const p = String(iso || '').slice(0, 10).split('-'); return p.length === 3 ? `${p[2]}-${p[1]}-${p[0]}` : ''; };

// Display-only preview. The server recomputes everything and is the source of truth.
export function calcLine(l, intra, inclusive = false) {
  const q = Number(l.qty) || 0, r = Math.round((Number(l.rate) || 0) * 100), d = Math.round((Number(l.discount) || 0) * 100);
  const pct = Number(l.gstPercent) || 0;
  const net = Math.max(Math.round(q * r) - d, 0);
  const taxable = inclusive ? Math.round((net * 100) / (100 + pct)) : net;
  const half = intra ? Math.round((taxable * pct) / 200) : 0;
  const igst = intra ? 0 : Math.round((taxable * pct) / 100);
  return { taxable: taxable / 100, cgst: half / 100, sgst: half / 100, igst: igst / 100, total: (taxable + 2 * half + igst) / 100 };
}
export function calcTotals(lines, intra, inclusive = false) {
  let t = 0, c = 0, s = 0, i = 0;
  for (const l of lines) {
    const x = calcLine(l, intra, inclusive);
    t += Math.round(x.taxable * 100); c += Math.round(x.cgst * 100); s += Math.round(x.sgst * 100); i += Math.round(x.igst * 100);
  }
  const total = t + c + s + i;
  return { taxable: t / 100, cgst: c / 100, sgst: s / 100, igst: i / 100, total: total / 100, grandTotal: Math.round(total / 100) };
}

let statesCache = null;
export function useStates() {
  const [states, setStates] = useState(statesCache || []);
  useEffect(() => {
    if (statesCache) return;
    gstAPI.states().then((r) => { statesCache = r.data.data; setStates(statesCache); }).catch(() => {});
  }, []);
  return states;
}
